import "src/pages/DataStudio/OpcoImport/components/styles_vanilla.css.ts.vanilla.css!=!../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/DataStudio/OpcoImport/components/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA61W227jIBB971cg9dkVdm0npV-DYXBobPBivEm62n9fgS_Bt6itNlJkmRnOnGHODH5RmsZpgdGfJ4Rqeo0uktsTQXGCcXN994umlIogjGhntVtpKOdSlQTFuXP5-_TSg8QeZLImaQ9QaMPBEBQ3V9TqSnL0LBIRg7gbI0O57FqCjjPAxANy2TYVvRFUGsndHveMLNRNRS1ETFddrVqCYmHGv_eizcgwIHUcOFF2Lo3uFHf7tSHoWfjfBqc46ffQSpYqkhbqliAGyoIJuL7OuUpVSQVRUWl2nhFIm-tEYiN3hCxcbWQNVa3QpiaI0UZaWslPcFahlY1a-Ql3Xn7pArI8WYJyjANSqSe1mSznPN2rjihei8wZR_fDEeMkD4CzXWAGjLM9YGDsLQ2BKX7FMQTA-VxDPy7XBHgYlO1EHBXaWl0vZXbsXaSKTsMpDuKfPN7mrEZVbaW4yH9Z3QdHNkWjX46GMRRv6beiARepiINoxVy4ooJ9tSP00bVWilvEtLKgbGgaJkc6xB7Pcnx3wFF7MlKdCQpFyjwBZyYofh8qMYCFfnybqMfl0gCzUiuC-nkwTYB5qWFbXuuThQxSwN-r46TIsEnTWXwRqtHqhqDouJhQU7k3IhxELrIHpPYn7cSg3OqHxSA_9RXxWdhbBQT5CRRqVN5dxtGTzUbPx3a1Vvrx5QPFdwp2nnpzvJiyeWtWy-feZEpwLOKwM9eGdSVZZ1q31Gg5ylw3lEl781rdZ0FO-jeYXS4sYQnd4jIYHgALzbr2x0k-AOaypUUFfA-b5SxjeAP7bhiPS2kb0arSF-CzI8Mv4SVSrxr__v2RLyaw8r7TfZQc4jy8NnRvXlcrvHffNy7on4-7-wm5fBWEDTi-6866KKGDm4GU68u4NqXQrEbDvBN-bac42c0XGrv9319o9gtBu-W35VjbfyUAKhp8CgAA\"}!../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var adminEmailHeader = 'noa14b7';
export var adminEmailSection = 'noa14b6';
export var arenaInfoGrid = 'noa14b2';
export var arenaSelectionCard = 'noa14b1';
export var buttonGroup = 'noa14bj';
export var changeButton = 'noa14bo';
export var clickableIcon = 'noa14bq';
export var container = 'noa14b0';
export var dataTypeSection = 'noa14bd';
export var dataTypeSelect = 'noa14be';
export var environmentBadge = 'noa14b3';
export var environmentBadgeProduction = 'noa14b4 noa14b3';
export var environmentBadgeTest = 'noa14b5 noa14b3';
export var fieldLabel = 'noa14bn';
export var fileCard = 'noa14b9';
export var fileCardReady = 'noa14ba';
export var fileContentSection = 'noa14bc';
export var fileIconContainer = 'noa14bb';
export var fileUploadContainer = 'noa14b8';
export var headerCard = 'noa14bs';
export var headerContent = 'noa14bt';
export var headerDescription = 'noa14bu';
export var headerSection = 'noa14br';
export var helpText = 'noa14bp';
export var importButton = 'noa14bk';
export var importError = 'noa14bi';
export var importProgress = 'noa14bh';
export var primaryBlackButton = 'noa14bl';
export var searchInputWrapper = 'noa14bm';
export var statusMessages = 'noa14bg';
export var submitSection = 'noa14bf';